import { h } from 'preact';
import styles from './ColorSwatch.module.scss';
function toKebabCase(value) {
    return 'swatch-' + (value || '').trim().toLowerCase().replace(/\s+/g, '-');
}
export function ColorSwatch({ options, onChange }) {
    return (h("div", { class: styles.colourSwatchList },
        options.map(option => {
            const normalizedValue = toKebabCase(option.value);
            return (h("button", { key: option.id, class: `${styles.colourSwatchItem} ${option.selected ? styles.selected : ''}`, onClick: () => onChange(option.id) },
                h("span", { class: `${styles.swatch} ${option.label === 'White' ? styles.swatchBorder : ''}`, style: `background-color: var(--${normalizedValue}, #b5b5b5)` }),
                h("span", { class: styles.label }, option.label),
                h("span", { class: styles.count },
                    "[",
                    option.count,
                    "]")));
        }),
        h("div", { class: styles.spacer })));
}
